export default {
  minimized: true,
  pinned: true,
  mouseover: false,
  automatic: null,
};
